/**
 * @generated SignedSource<<3c9fec29b7b13c27ac4fb45ae41180b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Conversation_conversation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shortId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ConversationHeader_conversation"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Messages_viewer"
    }
  ],
  "type": "Conversation",
  "abstractKey": null
};

node.hash = "f3948437dc44d479da78e9e2852bb383";

module.exports = node;
